export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openHumanResourceForm({commit}) {
        commit('setHumanResourceFormOpen');
    },
    closeHumanResourceForm({commit}) {
        commit('setHumanResourceFormClose');
    },

    openQualificationForm({commit}) {
        commit('setQualificationFormOpen');
    },
    closeQualificationForm({commit}) {
        commit('setQualificationFormClose');
    },

    openLanguageForm({commit}) {
        commit('setLanguageFormOpen');
    },
    closeLanguageForm({commit}) {
        commit('setLanguageFormClose');
    },

    openFeeForm({commit}) {
        commit('setFeeFormOpen');
    },
    closeFeeForm({commit}) {
        commit('setFeeFormClose');
    }
}
